import { qportalApi } from './qportal-api';
// Admin-only lookup for historical package labels; new fees come from Faqtoring quotes.
const getAllPackages = () => qportalApi.get('Packages');
export default { getAllPackages };
